import { useState, useContext } from "react";
import { loadState, saveState } from '../../../providers/localStorage';
import { localStorageName } from '../../../providers/localStorageData';
import { properties as propertiesAppData } from '../../../AppData';
import { useHistory } from "react-router-dom";
import AppContext from 'AppContext';
import { useParams } from "react-router-dom";
import { properties as appProperties } from '../../../AppData';
import { properties as cloudConfigProperties } from 'config/Config';
import AuthProvider from 'providers/authProvider';
import RestProvider from 'providers/RestProvider';
import useApp from 'AppFunctions';
import { objAttributesSeleccionConvocatoriaPerfil, objTextSeleccionConvocatoriaPerfil, properties } from './SeleccionConvocatoriaPerfilData';
import { useSelector, useDispatch } from "react-redux";
import { insertNewState, deleteState } from "redux/slicers/kingdomOV3Slice";

/**
 * @constant useFunctions
 * Contiene las funciones unificadas de la PCT2 y PCT3 que serán devueltas al formulario para que sean tratadas.
 */
const useFunctions = () => {
    /************************************
     * Valores obtenidos de estado global 
     ************************************/   
    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const convocatoriasProcedimientoPCT = useSelector((state) => state.kingdomOV3.convocatoriasProcedimientoPCT);

    const dispatch = useDispatch();
    const history = useHistory();
    const context = useContext(AppContext);
    const { idProcedimiento } = useParams();
    const objFields = {
        seleccionConvocatoria: '',
        perfil: '',
    };

    const [values, setValues] = useState(objFields);
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [mostrarMensajeBienvenida, setMostrarMensajeBienvenida] = useState(false);
    const [expandedMensajeBienvenida, setExpandedMensajeBienvenida] = useState('');
    const [procActual, setProcActual] = useState(procedimientoActual);
    const [mostrarVentana, setMostrarVentana] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [pintarPantalla, setPintarPantalla] = useState(false);
    const [convocatorias, setConvocatorias] = useState([]);
    const [metodosAcceso, setMetodosAcceso] = useState([]);

    // Inicialización necesaria para el componente Alert de mensajes y errores
    const [message, setMessage] = useState({ msg: "", severity: "" });
    const [alerts, setAlerts] = useState([]);
    let _ID = 0;

    const addAlert = (msg) => {
        setAlerts([...alerts, { id: _ID++, msg }]);
    }

    // Gestiona los mensajes de por pantalla para errores, info, etc...
    const handleSetMessage = (msg, severity) => {
        setMessage({ msg, severity });
        addAlert(message);
    }

    const handleLoanding = (booleano) => {
        setIsLoading(booleano);
    }

    const { checkCloudProperties } = AuthProvider();
    const { crudOperation, crudOperationsType } = RestProvider();
    const { firmar, loginClave, deleteCacheLocalStorage } = useApp(handleSetMessage, handleLoanding, false);

    // Obtención de los id del selector y del radioButton
    const idSelect = objAttributesSeleccionConvocatoriaPerfil.select.id;
    const idRadioGroup = objAttributesSeleccionConvocatoriaPerfil.radioButton.idRadioGroup;

    /***********************************
     * Funciones específicas de la PCT2
     ***********************************/

    /**
     * @function getConvocatoriasPCT2 Obtiene todas las convocatorias, las almacena y devuelve en un array.
     * @param {*} codRps 
     * @param {*} procedenciaProcedimiento 
     * @returns 
     */
    const getConvocatoriasPCT2 = async (codRps, procedenciaProcedimiento) => {
        let convocatorias = [];

        if (codRps !== null || procedenciaProcedimiento === 'PCT2') {
            let matchProcedimientos = [];
            let procedimientos = await getProcedimientosPCT2();
            let procedimientosRps = await getInfoProcedimientosRpsPCT2();
            
            // Obtención de las convocatorias del procedimiento actual de PCT2
            if (procedenciaProcedimiento === 'PCT2') {
                // Paso 2. Se realiza el match entre el procedimiento y su procedimiento RPS (en caso de que esté incluido en RPS)
                matchProcedimientos = await matchProcedimientosRPS(procedimientoActual, procedimientos, procedimientosRps);

            // Obtención de las convocatorias de procedimientos de PCT2 a través de un código RPS
            } else {
                if (codRps !== null) {
                    // Paso 1. Filtrado de los procedimientos RPS almacenados en bbdd a través del código RPS
                    let procedimientosRpsObtenidos = procedimientosRps.filter((proc)=> proc.codigoRpa === codRps);

                    // Paso 2. Obtención de los procedimientos a partir de los procedimientos RPS
                    if (procedimientosRpsObtenidos.length > 0) {
                        for (const procRps of procedimientosRpsObtenidos) {
                            for (const proc of procedimientos) {
                                if (procRps.idProcedimiento === proc.id) {
                                // Paso 2.1. Se realiza el match entre el procedimiento y su procedimiento RPS (en caso de que esté incluido en RPS)
                                    let match = await matchProcedimientosRPS(proc, procedimientos, procedimientosRps);
                                    
                                    // Paso 2.2. Se insertan en el array que contiene los procedimientos que han hecho match
                                    matchProcedimientos.push(...match);
                                }
                            }
                        }
                    }
                }
            }
            // Paso 3. Se obtienen las convocatorias de los procedimientos recibidos
            convocatorias = (matchProcedimientos.length > 0) && await getConvocatoriasFromProcedimiento(matchProcedimientos);
        }

        return convocatorias;
    }

    /**
     * @function getConvocatoriasFromProcedimiento Función que obtiene las convocatorias de los procedimientos recibidos
     * @returns 
     */
    const getConvocatoriasFromProcedimiento = async (procedimientos) => {      
        let ordenesObtenidas = []; 
        let convocatoriasObtenidas = [];

        if (procedimientos.length > 0) {
            for (let procActual of procedimientos) {
                if (procActual.ordenes !== undefined) {                    
                    ordenesObtenidas.push(...procActual.ordenes.map(orden => ({
                        ...orden,
                        idProc: procActual.id,
                        descripcionProc: (procActual.descripcion !== undefined) ? procActual.descripcion : '',
                        descripcionProcRps: (procActual.descripcionRPS !== undefined) ? procActual.descripcionRPS : '',
                        descripcionCortaProc: (procActual.descripcionCorta !== undefined) ? procActual.descripcionCorta : '',
                        plazoProc: (procActual.plazo !== undefined) ? procActual.plazo : ''

                    })));
                }
            }
        }

        ordenesObtenidas.forEach(buscarOrden => {
            let convocatorias = buscarOrden.convocatorias;

            convocatoriasObtenidas.push(...convocatorias.map(convo => ({
                ...convo,
                idProc: buscarOrden.idProc,
                descripcionProc: buscarOrden.descripcionProc,
                descripcionProcRps: buscarOrden.descripcionProcRps,
                descripcionCortaProc: buscarOrden.descripcionCortaProc,
                plazoProc: buscarOrden.plazoProc,
                procedencia: 'PCT2'
            })));
        });
        return convocatoriasObtenidas;
    }

    /**
     * @function getPerfilConvocatoriaPCT2 Obtiene los perfiles de la convocatoria seleccionada por el usuario y los devuelve en un array
     * @param {*} idConvocatoriaSeleccionada Convocatoria seleccionada por el usuario en el selector
     */
    const getPerfilConvocatoriaPCT2 = (convocatorias, idConvocatoriaSeleccionada) => {
        let perfilesObtenidos = [];

        convocatorias && convocatorias.forEach(buscarConvocatoria => {
            let perfiles = buscarConvocatoria.perfiles;

            perfiles.forEach(buscarPerfil => {
                if (buscarConvocatoria.id === idConvocatoriaSeleccionada) {

                    if (idConvocatoriaSeleccionada === buscarPerfil.idConvocatoria) {
                        perfilesObtenidos.push(buscarPerfil);
                    }
                }
            })
        })
        return perfilesObtenidos;
    }

    /**
     * @function getPerfilesPCT2 Obtiene todos los perfiles con la descripción del perfil NO repetida y que los perfiles sean públicos. Los perfiles son almacenados y devueltos en un array.
     * @param conv Convocatorias recibidas por parámetros 
     * @returns Devuelve los perfiles obtenidos
     */
    const getPerfilesPCT2 = (conv) => {
        let perfilesObtenidos = [];
        let convocatoriasObtenidas = (conv === undefined) ? convocatorias : conv;    
        convocatoriasObtenidas && convocatoriasObtenidas.forEach(buscarConvocatoria => {
            let perfiles = buscarConvocatoria.perfiles;
            perfiles.forEach(buscarPerfiles => {
                /* Se crea objeto asignandole el objeto buscarPerfiles para despues poder añadirle la propiedad nombre*/
                let nombrePerfiles = Object.assign({}, buscarPerfiles);
                /* Copiamos el valor de descripción a nombre para igualarla con los perfiles de PCT3*/
                Object.assign(nombrePerfiles, {'nombre':buscarPerfiles.descripcion});
                let perfilAdd = nombrePerfiles;
                let perfilPublico = perfilAdd.publico;
                /*Si el perfil a añadir no existe se añade al array de perfiles obtenidos
                (la condición es que no exista en el array de perfiles obtenidos y que su descripción no esté repetida en el array de perfiles) y además debe contener un perfil público.*/
                if (!getPerfilExistentePCT2(perfilesObtenidos, perfilAdd) && perfilPublico) {
                    perfilesObtenidos.push(perfilAdd);
                }
            })
        })
        return perfilesObtenidos;
    }

    /**
     * @function getEstadoSaltoBandejaPCT2 Función que indica si se realiza el salto a la bandeja. 
     * @param {*} infoUsuario Información del usuario
     * @param {*} tiposIdentificacionObtenidos Tipos de identificación
     * @returns Devuelve un valor booleano que indica si se produce o no el salto a la bandeja
     */
    const getEstadoSaltoBandejaPCT2 = (infoUsuario, tiposIdentificacionObtenidos) => {
        let saltoActivado = false;

        if ((infoUsuario !== undefined && infoUsuario !== '') && infoUsuario.tipoAutenticacion !== undefined) {
            let codeTipoAutenticacion = infoUsuario.tipoAutenticacion;
            let idTipoAutenticacion;

            if (codeTipoAutenticacion === objAttributesSeleccionConvocatoriaPerfil.buttons.certificadoDigital.code) {
                idTipoAutenticacion = objAttributesSeleccionConvocatoriaPerfil.buttons.certificadoDigital.id;
            } else if (codeTipoAutenticacion === objAttributesSeleccionConvocatoriaPerfil.buttons.entradaClave.code) {
                idTipoAutenticacion = objAttributesSeleccionConvocatoriaPerfil.buttons.entradaClave.id;
            }

            tiposIdentificacionObtenidos.forEach(iterador => {
                if (iterador.id === idTipoAutenticacion) {
                    saltoActivado = true;
                }
            });
        }
        return saltoActivado;
    }

    /**
     * @function getEstadoBotonPCT2 comprueba si el tipo de indentificación está disponible para el perfil seleccionado, de la convocatoria seleccionada.
     * Devuelve un valor booleano.
     * @param perfilSeleccionado recibe un array de objetos del perfilSeleccionado
     * @param idButton recibe el ID del botón que se habilitará/deshabilitará
     */
    const getEstadoBotonPCT2 = (perfilSeleccionado, idButton) => {
        let disabled = true;
        
        if (perfilSeleccionado) {
            let perfil = typeof perfilSeleccionado ==='string' ? JSON.parse(perfilSeleccionado) : perfilSeleccionado
            let tiposIdentificacionObtenidos = perfil.tiposIdentificacion; //Array de objetos de los tipos de identificación del perfil seleccionado.

            let saltoActivado = getEstadoSaltoBandejaPCT2(infoUsuario, tiposIdentificacionObtenidos);

            if (idButton === objAttributesSeleccionConvocatoriaPerfil.buttons.saltoABandeja.id) {
                disabled = !saltoActivado;
            }

            tiposIdentificacionObtenidos && tiposIdentificacionObtenidos.forEach(iterador => {

                if (!saltoActivado && idButton != objAttributesSeleccionConvocatoriaPerfil.buttons.saltoABandeja.id) {
                    if (iterador.id === idButton) {
                        disabled = false;
                    }
                }
            });
        }
        return disabled;
    }

    /**
     * @function getProcedimientosPCT2 Función que obtiene los procedimientos de la PCT2
     * @returns Devuelve los procedimientos obtenidos
     */
    const getProcedimientosPCT2 = async () => {
        let respuesta = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROCEDIMIENTOS_PCT2, { url: '', method: 'get' }).then(response => {
            respuesta = response.data;
        }).catch(function (error) {
            handleSetMessage('Se ha producido un error al obtener los procedimientos', 'error');
        });
        return respuesta;
    }

    /**
     * @function compruebaUsuarioPCT2 Función que comprueba la siguiente información del usuario:
     * 
     * Login con certificado:
     *  - Si el usuario no existe en la aplicación, se realiza una redirección hacia la pantalla de alta de usuario
     *  - Si el usuario existe en la aplicación, se realiza una redirección hacia la bandeja de solicitudes
     *  - Si se produce un error que no sea el 404, se lanza una excepción.
     * Login con clave:
     *  - Si se produce un error al realizar el login con clave, se lanza una excepción.
     */
    const compruebaUsuarioPCT2 = async () => {
        let errorClave = loadState(localStorageName.errorClave, true);
        //Se obtiene el valor booleano del campo gestionadoEnOV3, el cual indica si se gestiona o no en la bandeja nueva (OV3).
        let saltoBandejaNueva = procedimientoActual.gestionadoEnOV3;

        if (errorClave !== undefined) {
            handleSetMessage(errorClave.errorClave.mensaje, 'error');
            localStorage.removeItem('errorClave');
        } else if (infoUsuario !== undefined && infoUsuario !== '') {
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_INTERESADO_ENTIDAD, { url: properties.URL_CARGA_PANTALLA_INTERESADO, method: 'post', data: obtenerDatosUsuarioClave() }).then(response => {
                let interesado = response.data.interesado;
                if (interesado === null) {
                    ventanaUsuarioSinAltaAbrirCerrar(true);
                } else {
                    if (saltoBandejaNueva) {
                        redirectBandejaSolicitudes(history);
                    } else {
                        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SALTO_BANDEJA, { url: "/", method: 'post', data: obtenerDatosSaltoBandeja() }).then(responseSalto => {
                            saveState(localStorageName.redirect, 'bandeja', false);
                            window.location.href = responseSalto.data;
                        }).catch(function (error) {
                            if (error.response.status != 404) {
                                handleSetMessage("Ha ocurrido un error al intentar saltar a la bandeja.", 'error');
                            }
                        });
                    }
                }
            }).catch(function (error) {
                if (error.response && error.response.status === 404) {
                    ventanaUsuarioSinAltaAbrirCerrar(true);
                } else {
                    handleSetMessage("Ha ocurrido un error al intentar recuperar los datos.", 'error');
                }
            });
        }
    }

    /**
     * @function montarPnatallaPorUrlPCT2 Función que monta la pantalla através de URL sin necesidad de navegación en la app 
     */
    const montarPantallaPorUrlPCT2 = async (procedimiento) => {
        let procedimientoWithRPS = null;
        let procedimientosObtenidos = null;

        if (procedimiento === undefined || procedimiento === null || procedimiento === '') {
            let dataProc = idProcedimiento.split('_');

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROCEDIMIENTOS_PCT2, {
                url: properties.RESOURCE_GET_PROCEDIMIENTOS + "/" + dataProc[1], method: 'get'}).then(response => {
                    procedimientosObtenidos = response.data;
            }).catch(function (error) {
                handleSetMessage('Se ha producido un error al obtener el procedimiento' ,'error' );
            });
            procedimientoWithRPS = await addDataRpsPCT2(procedimientosObtenidos);
            dispatch(insertNewState({filnedName: 'procedimientoActual', value: procedimientoWithRPS}));
            setProcActual(procedimientoWithRPS);
            deleteCacheLocalStorage();
        }
        return procedimientoWithRPS === null ? procedimiento : procedimientoWithRPS;
    }

    /***********************************
     * Funciones auxiliares
     ***********************************/

    /**
     * @function obtenerDatosUsuarioClave Función auxiliar de compruebaUsuarioPCT2, obtiene los datos del usuario de clave.
     * @returns Devuelve los datos del usuario
     */
    const obtenerDatosUsuarioClave = () => {

        let datosSaltousuarioClave = {
            interesadoNif: infoUsuario.interesadoNif,
            interesadoNombre: infoUsuario.interesadoNombre,
            interesadoApellido1: infoUsuario.interesadoApellido1,
            interesadoApellido2: infoUsuario.interesadoApellido2,
            entidadCif: infoUsuario.entidadCif,
            entidadNombre: infoUsuario.entidadNombre,
        }
        return datosSaltousuarioClave;
    }

    /**
     * @function obtenerDatosSaltoBandeja Función auxiliar de compruebaUsuarioPCT2, obtiene los datos del usuario del certificado
     * @returns Devuelve los datos del usuario
     */
    const obtenerDatosSaltoBandeja = () => {
        let datosSaltoBandeja = {
            tipoAutenticacion: infoUsuario.tipoAutenticacion,
            nifUsuario: infoUsuario.interesadoNif,
            nombre: infoUsuario.interesadoNombre,
            apellido1: infoUsuario.interesadoApellido1,
            apellido2: infoUsuario.interesadoApellido2,
            idProcedimientoActivo: procedimientoActual.id,
            idConvocatoriaActiva: convocatoriaSeleccionada.id,
            idOrdenActiva: convocatoriaSeleccionada.idOrden,
            idPerfilActivo: perfilSeleccionado.id,
            urlSalto: procedimientoActual.url,
            datosCertificado: infoUsuario.datosCertificado
        }
        return datosSaltoBandeja;
    }

    /***********************************
     * Funciones especificas de la PCT3
     ***********************************/

    /**
     * @function getConvocatoriasPCT3 Función que obtiene las convocatorias pertenecientes a la PCT3,
     * obtiene las convocatorias direcatamente a través del id del procedimiento o através del código RPS.
     * @param codRps Código RPS
     * @returns Devuelve las convocatorias de PCT3
     */
    const getConvocatoriasPCT3 = async (codRps, procedenciaProcedimiento) => {
        let convocatorias = [];

        if (!convocatoriasProcedimientoPCT) {
            if (procedenciaProcedimiento === 'PCT3') {
                // Obtención de convocatorias de un procedimiento de PCT3 a través de su idProcedimiento
                await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_CONVOCATORIAS, { url: properties.RESOURCE_GET_CONVOCATORIAS + idProcedimiento.split('_')[1], method: 'get' }).then(response => {
                    convocatorias = response.data;
                });
            } else {
                // Obtención de convocatorias de un procedimiento de PCT3 a través de su código RPS
                if (codRps !== null) {
                    await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_CONVOCATORIAS, {url: properties.URL_CONVOCATORIAS_BY_RPS + codRps}).then(response => {
                        convocatorias = response.data;
                    }).catch(function (error) {
                        return convocatorias;
                    });
                }
            }

            // Tratamiento de los perfiles para añadir la clave descripción y para incluir la procedencia de la convocatoria
            if (convocatorias.length !== 0) {
                convocatorias.forEach(convo => {
                    Object.assign(convo, {"procedencia": "PCT3"});
                    convo.perfiles.forEach(p => {
                        Object.assign(p, { "descripcion": p.codigo });
                        delete p.codigo;
                    });
                });
                dispatch(insertNewState({filnedName: 'convocatoriasProcedimientoPCT', value: convocatorias}));
            }
        } else {
            // Se incluye la procedencia de las convocatorias
            convocatorias = convocatoriasProcedimientoPCT.map(convo => ({
                ...convo,
                procedencia: 'PCT3'
            }));
            dispatch(insertNewState({filnedName: 'convocatoriasProcedimientoPCT', value: convocatorias}));
        }

        return convocatorias;
    }

    /**
     * @function getPerfilesPCT3 Función que obtiene los perfiles de las convocatorias pertenecientes a la PCT3
     * @param conv Convocatorias recibidas por parámetros
     * @returns Devuelve los perfiles de PCT3
     */
    const getPerfilesPCT3 = (conv) => {
        let perfilesObtenidos = [];
        let convocatoriasObtenidas = (conv === undefined) ? convocatorias : conv;
        
        convocatoriasObtenidas.forEach(buscarConvocatoria => {
            if (buscarConvocatoria.procedencia === 'PCT3') {
                let perfiles = buscarConvocatoria.perfiles;
                perfiles.forEach(buscarPerfiles => {
                    let perfilAdd = buscarPerfiles;
                    (!getPerfilExistente(perfilesObtenidos, perfilAdd)) && perfilesObtenidos.push(perfilAdd);
                });
            }
        });
        return perfilesObtenidos;
    }

    /**
     * @function mostrarAcceso Función que obtiene los métodos de acceso disponibles en las convocatorias obtenidas
     */
    const mostrarAcceso = async () => {
        let metodosPermitidos = [];

        if (await getProcedenciaProcedimiento() === 'PCT2') {
            metodosPermitidos = ['Certificado', 'CLAVE', 'Anonimo'];
        } else {
            if (convocatorias !== undefined && convocatorias !== null && convocatorias !== '' && convocatorias.length !== 0) {
                convocatorias.forEach(buscarConvocatoria => {
                    let tiposIdentificacion = buscarConvocatoria.tiposIdentificacion;
                    tiposIdentificacion.forEach(objeto => {
                        metodosPermitidos.push(objeto.codigo);
                    });
                });
            }
        }
        setMetodosAcceso(metodosPermitidos);
    }

    /**
     * @function getPerfilConvocatoriaPCT3 Función que obtiene los perfiles de una convocatoria perteneciente a la PCT3
     * @param {*} convocatorias Recibe las convocatorias
     * @returns Devuelve un array con los perfiles obtiendos
     */
    const getPerfilConvocatoriaPCT3 = (convocatorias, idConvocatoriaSeleccionada) => {
        let perfilesObtenidos = [];

        convocatorias.forEach(buscarConvocatoria => {
            let perfiles = buscarConvocatoria.perfiles;
            perfiles.forEach(buscarPerfil => {
                (buscarConvocatoria.id === idConvocatoriaSeleccionada) && perfilesObtenidos.push(buscarPerfil);
            });
        });
        return perfilesObtenidos;
    }

    /**
     * @function getEstadoSaltoBandejaPCT3 Función que indica si se realiza el salto a la bandeja
     * @param {*} infoUsuario Contiene la información del usuario logado
     * @param {*} tiposIdentificacionObtenidos Array con los tipos de idenficiadores obtenidos
     * @returns Devuelve un valor booleano, el cual indicará si se realiza el salto a la bandeja
     */
    const getEstadoSaltoBandejaPCT3 = (infoUsuario, tiposIdentificacionObtenidos) => {

        let saltoActivado = false;
        if ((infoUsuario !== undefined && infoUsuario !== '') && infoUsuario.tipoAutenticacion !== undefined) {
            let codeTipoAutenticacion = infoUsuario.tipoAutenticacion;
            let idTipoAutenticacion;

            if (codeTipoAutenticacion === objAttributesSeleccionConvocatoriaPerfil.buttons.certificadoDigital.code) {
                idTipoAutenticacion = properties.CODIGO_CERTIFICADO;
            } else if (codeTipoAutenticacion === objAttributesSeleccionConvocatoriaPerfil.buttons.entradaClave.code) {
                idTipoAutenticacion = properties.CODIGO_CLAVE;
            } else if (codeTipoAutenticacion === objAttributesSeleccionConvocatoriaPerfil.buttons.entradaRegistrado.code) {
                idTipoAutenticacion = properties.CODIGO_REGISTRADO;
            }

            tiposIdentificacionObtenidos.forEach(iterador => {
                if (iterador.codigo.toUpperCase() === idTipoAutenticacion.toUpperCase()) {
                    saltoActivado = true;
                }
            });
        }
        return saltoActivado;
    }

    /**
     * @function getEstadoBotonPCT3 comprueba si el tipo de indentificación está disponible para el perfil seleccionado, de la convocatoria seleccionada.
     * Devuelve un valor booleano.
     * @param codigoOV3 recibe el código del botón que se habilitará/deshabilitará
     * @param idButton recibe el id del botón que se habilitará/deshabilitará
     */
    const getEstadoBotonPCT3 = (idButton, codigoOV3) => {
        let disabled = true;

        if (perfilSeleccionado !== undefined && perfilSeleccionado !== '' && perfilSeleccionado) {
            let tipoAutenticacion = convocatoriaSeleccionada.tiposIdentificacion;
            let saltoActivado = getEstadoSaltoBandejaPCT3(infoUsuario, tipoAutenticacion);

            if (idButton === objAttributesSeleccionConvocatoriaPerfil.buttons.saltoABandeja.id) {
                disabled = !saltoActivado;
            }

            tipoAutenticacion.forEach(iterador => {
                if (!saltoActivado && idButton !== objAttributesSeleccionConvocatoriaPerfil.buttons.saltoABandeja.id && codigoOV3 !== undefined) {
                    if (iterador.codigo.toLowerCase() === codigoOV3.toLowerCase()) {
                        disabled = false;
                    }
                }
            });
        }
        return disabled;
    }

    /**
     * @function compruebaUsuarioPCT3 Función que comprueba la siguiente información del usuario:
     * 
     * Login con certificado:
     *  - Si el usuario no existe en la aplicación, se realiza una redirección hacia la pantalla de alta de usuario
     *  - Si el usuario existe en la aplicación, se realiza una redirección hacia la bandeja de solicitudes
     *  - Si se produce un error que no sea el 404, se lanza una excepción.
     * Login con clave:
     *  - Si se produce un error al realizar el login con clave, se lanza una excepción.
     */
    const compruebaUsuarioPCT3 = async () => {
        let errorClave = loadState(localStorageName.errorClave, true);

        if (errorClave !== undefined) {
            handleSetMessage(errorClave.errorClave.mensaje, 'error');
            localStorage.removeItem('errorClave');
        } else if (infoUsuario !== undefined && infoUsuario !== '') {
            let interesadoBuscado = {
                identificador: infoUsuario.interesadoNif,
                identificadorEntidad: infoUsuario.entidadCif
            };

            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_INTERESADO, { url: properties.RESOURCE_OBTENER_DATOS_INTERESADO, method: 'post', data: interesadoBuscado }).then(response => {
                redirectBandejaSolicitudes(history);
            }).catch(function (error) {
                (error.response.data.errorCode === 404) ? ventanaUsuarioSinAltaAbrirCerrar(true) : handleSetMessage(errorClave.errorClave.mensaje, 'error');
            });
        }
    }

    /**
     * @function montarPantallaPorUrlPCT3 Función que monta la pantalla através de URL sin necesidad de navegación en la app
     */
    const montarPantallaPorUrlPCT3 = async (procedimiento) => {

        let dataProc = idProcedimiento.split('_');
        let procedimientosWithRPS = null;
        let procedimientosObtenidos = null;

        if (procedimiento === undefined || procedimiento === null || procedimiento === '') {
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROCEDIMIENTOS_PCT3, {
                url: '/' + dataProc[1], method: 'get' }).then(response => {
                procedimientosObtenidos = response.data;
            }).catch(function (error) {
                handleSetMessage('Se ha producido un error al obtener el procedimiento', 'error');
            });
            procedimientosWithRPS = await addDataRpsPCT3(procedimientosObtenidos);
            procedimientosWithRPS.fromPct3 = true;
            dispatch(insertNewState({filnedName: 'procedimientoActual', value: procedimientosWithRPS}));
            setProcActual(procedimientosWithRPS);
            deleteCacheLocalStorage();
        }
        return procedimientosWithRPS === null ? procedimiento : procedimientosWithRPS;
    }

    /***********************************
     * Funciones de unificación
     ***********************************/

    /**
     * @function getProcedenciaProcedimiento Función que obtiene la procedencia del procedimiento actual
     */
    const getProcedenciaProcedimiento = async () => {
        let urlProcedenciaProcedimiento = await getUrlProcedimiento();
        return urlProcedenciaProcedimiento.substring(1,5) === 'PCT3' ? 'PCT3' : 'PCT2';
    }

    /**
     * @function getProcedenciaConvocatoria Función que obtiene la procedencia de la convocatoria actual
     */
    const getProcedenciaConvocatoria = (convocatoria)  => {
        
        if (convocatoria === undefined || convocatoria === '') {
            convocatoria = convocatoriaSeleccionada;
        }

        return ((convocatoria !== undefined && convocatoria !== '') && convocatoria.procedencia !== undefined) && convocatoria.procedencia;
    }

    /**
     * @function getConvocatorias Función que obtiene las convocatorias correspondientes al sistema al que pertenezca el procedimiento (PCT2 o PCT3) 
     * @returns Devuelve un array de convocatorias
     */
    const getConvocatorias = async () => {
        let procedenciaProcedimiento = await getProcedenciaProcedimiento();
        let convocatoria = [], convPCT2, convPCT3;
        let codRps = await getCodRpsFromProcedimiento();

        // Paso 1. Se obtienen las convocatorias de PCT2
        convPCT2 = await getConvocatoriasPCT2(codRps, procedenciaProcedimiento);

        // Paso 2. Se obtienen las convocatorias de PCT3
        convPCT3 = await getConvocatoriasPCT3(codRps, procedenciaProcedimiento);

        // Paso 3. Se unifican las convocatorias
        (convPCT2.length > 0) && convocatoria.push(...convPCT2);
        (convPCT3.length > 0) && convocatoria.push(...convPCT3);
        return convocatoria;
    }

    /**
     * @function getPerfilConvocatoria Función que obtiene el perfil de las convocatorias correspondientes al sistema al que pertenezca la convocatoria (PCT2 o PCT3)
     * @param convocatoria Recibe  la convocatoria seleccionada
     * @returns Devuelve el perfil de la convocatoria
     */
    const getPerfilConvocatoria = (convocatoria) => {
        let procedenciaConvocatoria = getProcedenciaConvocatoria(convocatoria);
        let perfilConvocatoria = (procedenciaConvocatoria === 'PCT3') ? getPerfilConvocatoriaPCT3(convocatorias, convocatoria.id) : getPerfilConvocatoriaPCT2(convocatorias, convocatoria.id);
        return perfilConvocatoria;
    }

    /**
     * @function getEstadoBoton Función que comprueba si el tipo de indentificación está disponible para el perfil seleccionado de la convocatoria seleccionada correspondiente al sistema al que pertenece (PCT2 o PCT3).
     * @param perfilSeleccionado recibe un array de objetos del perfilSeleccionado
     * @param atributos recibe los atributos del boton
     * @returns Devuelve un valor booleano.
     */
    const getEstadoBoton = (perfilSeleccionado, atributos) => {
        let procedenciaConvocatoria = getProcedenciaConvocatoria();
        let estadoBoton = (procedenciaConvocatoria === 'PCT3' ? getEstadoBotonPCT3(atributos.id, atributos.codigoOV3) : getEstadoBotonPCT2(perfilSeleccionado, atributos.id));
        return estadoBoton;
    }

    /**
     * @function compruebaUsuario Función que comprueba la siguiente información del usuario, dependiendo del
     * sistema al que pertenezca la convocatoria (PCT2 o PCT3):
     * 
     * Login con certificado:
     *  - Si el usuario no existe en la aplicación, se realiza una redirección hacia la pantalla de alta de usuario
     *  - Si el usuario existe en la aplicación, se realiza una redirección hacia la bandeja de solicitudes
     *  - Si se produce un error que no sea el 404, se lanza una excepción.
     * Login con clave:
     *  - Si se produce un error al realizar el login con clave, se lanza una excepción.
     */
    const compruebaUsuario = async () => {
        setIsLoading(true);
        let procedenciaConvocatoria = getProcedenciaConvocatoria();
        (procedenciaConvocatoria === 'PCT3') ? await compruebaUsuarioPCT3() : await compruebaUsuarioPCT2();
    }

    /**
     * @function montarPantallaPorUrl Función que monta la pantalla através de URL sin necesidad de navegación en la app,
     * dependiendo del sistema al que pertenezca el procedimiento (PCT2 o PCT3).
     */
    const montarPantallaPorUrl = async () => {
        let res;
        let urlProcedenciaProcedimiento = await getUrlProcedimiento();
        if (urlProcedenciaProcedimiento.substring(1, 5) === 'PCT3') {
            res = await montarPantallaPorUrlPCT3(procedimientoActual);
        } else {
            res = await montarPantallaPorUrlPCT2(procedimientoActual);
        }
        setProcActual(res);
    }

    /**
     * @function guardarProcActual Función que realiza el guardado del procedimiento, independientemente del sistema del que provenga
     * @param {*} idProcedimiento 
     */
    const guardarProcActual = async (procedencia, convocatoria) => {
        
        // Paso 1. Se comprueba el contenido de los parámetros
        if ((convocatoria !== undefined && convocatoria !== null) && (procedencia === 'PCT3' || procedencia === 'PCT2')) {
            let idProcedimiento = (procedencia === 'PCT3') ? convocatoria.idProcedimiento : convocatoria.idProc;
        
            // Paso 2. Se comprueba si el procedimiento actual no es el mismo que el que se va a guardar
            if (procActual.idProcedimiento !== idProcedimiento) {

                // Paso 3. Se comprueba la procedencia para realizar el guardado del procedimiento
                let proc = (procedencia === 'PCT3')
                    ? await guardarProcActualPCT3(idProcedimiento)
                    : await guardarProcActualPCT2(idProcedimiento);
                
                // Paso 4. Acciones del guardado del procedimiento    
                if (proc !== undefined && proc != null) {
                    context.updateTitlePage(objTextSeleccionConvocatoriaPerfil.titulos.tituloPagina + ((proc.descripcion === undefined) ? proc.nombre : proc.descripcion));
                    dispatch(insertNewState({filnedName: 'procedimientoActual', value: proc}));
                    setProcActual(proc);
                    comprobarMensajeBienvenida();
                    updateUrl(proc, procedencia);
                }
            }
        }
    }

    /***********************************
     * Funciones comúnes
     ***********************************/

    /**
     * @function redirectBandejaSolicitudes Función que realiza la redirección a la bandeja de solicitudes
     * @param {*} history 
     */
    const redirectBandejaSolicitudes = (history) => {
        setIsLoading(true);
        dispatch(insertNewState({filnedName: 'accesoBandejaSol', value: true}));
        history.push('/BandejaSolicitudes');
        setIsLoading(false);;
    }

    /**
     * @function addDataRpsPCT2 Función que obtiene los datos de RPS y los añade al procedimietno
     * @param {*} procedimiento Procedimiento obtenido
     * @returns Devuelve el procedimiento con los datos de RPS incluídos en el
     */
    const addDataRpsPCT2 = async (procedimiento) => {
        let procedimientosRps = await getProcedimientosRPS();
        let listInfoRpsPct = await getInfoProcedimientosRpsPCT2();

        let infoRps = listInfoRpsPct.filter(info =>
            (info.nombreProcedimiento ? info.nombreProcedimiento.toLowerCase() : '') === (procedimiento.nombre ? procedimiento.nombre.toLowerCase() : ''))

        if (infoRps && infoRps[0]) {
            let procedimientoRps = procedimientosRps.filter((procRps) => procRps.codigoRPA === infoRps[0].codigoRpa);
            if (procedimientoRps && procedimientoRps[0]) {
                procedimiento = {
                    ...procedimiento,
                    "descripcion": procedimientoRps[0].nombre,
                    "descripcionCorta": procedimientoRps[0].familia,
                }
            }
        }
        return procedimiento;
    }

    /**
     * @function addDataRpsPCT3 Función que obtiene los datos de RPS y los añade al procedimietno
     * @param {*} procedimiento Procedimiento obtenido
     * @returns Devuelve el procedimiento con los datos de RPS incluídos en el
     */
    const addDataRpsPCT3  = async (procedimiento) => {
        let procedimientosRps = await getProcedimientosRPS();
        if (procedimientosRps.length > 0 && procedimiento.codigoRps) {
            let procedimientoRps = procedimientosRps.filter((procRps) => procRps.codigoRPA === procedimiento.codigoRps);
            if (procedimientoRps && procedimientoRps[0]) {
                procedimiento = {
                    ...procedimiento,
                    "descripcion": procedimientoRps[0].nombre,
                    "descripcionCorta": procedimientoRps[0].familia,
                }
            }
        }
        return procedimiento;
    }

    /**
     * @function getListConvocatorias Función que obtiene el listado de convocatorias
     */
    const getListConvocatorias = async () => {
        let perfilesPublicos = [];
        let listaConvocatorias = await getConvocatorias();        
        setConvocatorias(listaConvocatorias);
        let procedenciaProcedimiento = await getProcedenciaProcedimiento();

        if (listaConvocatorias && listaConvocatorias.length === 1) {

            listaConvocatorias[0].perfiles.forEach((perfil) => {
                if (procedenciaProcedimiento === 'PCT3') {
                    perfilesPublicos.push(perfil);
                } else {
                    perfil.publico && perfilesPublicos.push(perfil);
                }
            });

            //SELECCIONAR DIRECTAMENTE
            if (perfilesPublicos.length === 1) {
                //Si solo existe una convocatoria y un perfil lo marca directamente
                setValues({
                    ...values,
                    [idSelect]: listaConvocatorias[0],
                    [idRadioGroup]: JSON.stringify(perfilesPublicos[0])
                });
                dispatch(insertNewState({filnedName: 'perfilSeleccionado', value: perfilesPublicos[0]}));
            } else {
                //Si solo existe una convocatoria la marca directamente
                setValues({
                    ...values,
                    [idSelect]: listaConvocatorias[0],
                });
            }
            dispatch(insertNewState({filnedName: 'convocatoriaSeleccionada', value: listaConvocatorias[0]}));

            const hash = window.location.hash;
            const partes = hash.split('/');
            const urlProcedimiento = "/" + partes[2];
            dispatch(insertNewState({filnedName: 'urlProcedenciaProcedimiento', value: urlProcedimiento}));
            localStorage.setItem('urlProcedenciaProcedimiento', urlProcedimiento);
            comprobarMensajeBienvenida();
        }
    }

    /**
     * @function matchProcedimientosRPS Función que comprueba si el procedimiento actual se encuentra entre los procedimientos RPS.
     * En caso de que se cumpla esta condición, se realizará un match entre el procedimiento actual y el procedimiento RPS.
     * @param {*} procedimientoActual Procedimiento actual
     * @param {*} procedimientosObtenidos Procedimientos obtenidos de PCT2
     * @param {*} procedimientosRps Procedimientos RPS almacenados en BBDD
     * @returns Devuelve un array de procedimientos
     */
    const matchProcedimientosRPS = async (procedimientoActual, procedimientosObtenidos, procedimientosRps) => {
        let listProcedimientosActuales = [];

        // Paso 1. Se comprueba si se ha obtenido el listado de los procedimientos RPS con su correspondiente información
        if (procedimientosRps) {

            // Paso 2. Se realiza un filtrado del listado de procedimientos RPS obtenidos y se comprueba si el procedimiento actual se encuentra entre ellos, através de su nombre.
            let infoProcActual = procedimientosRps.filter((info) =>
                (info.nombreProcedimiento ? info.nombreProcedimiento.toLowerCase() : '') === (procedimientoActual.nombre ? procedimientoActual.nombre.toLowerCase() : '')
            );

            // Paso 3. Se comprueba si el procedimiento actual se encuentra dentro del listado de procedimientos RPS obtenidos
            if (infoProcActual && infoProcActual.length > 0) {

                // Paso 3.1. Se realiza un filtrado del listado de procedimientos RPS obtenidos y se comprueba si el procedimiento actual se encuentra entre ellos, através de su código RPA.
                let listInfoProcActuales = procedimientosRps.filter((info) =>
                    (info.codigoRpa ? info.codigoRpa.toLowerCase() : '') === (infoProcActual[0].codigoRpa ? infoProcActual[0].codigoRpa.toLowerCase() : '')
                );

                // Paso 4. Se comprueba si el listado de procedimientos actuales contiene procedimientos
                if (listInfoProcActuales && listInfoProcActuales.length > 1) {

                    // Match de varios procedimientos con RPS
                    for (const infoProcActuales of listInfoProcActuales) {

                        let procedimientoArray = procedimientosObtenidos.filter((proc) =>
                            (proc.nombre ? proc.nombre.toLowerCase() : '') === (infoProcActuales.nombreProcedimiento ? infoProcActuales.nombreProcedimiento.toLowerCase() : '')
                        );

                        if (procedimientoArray && procedimientoArray[0]) {
                            let procedimiento = {
                                ...procedimientoArray[0],
                                "descripcionRPS": procedimientoActual.descripcion,
                                "descripcionCorta": procedimientoActual.descripcionCorta,
                                "plazo": procedimientoActual.plazo
                            }
                            listProcedimientosActuales.push(procedimiento);
                        }
                    }
                } else {
                    /**
                     * Paso 4. en caso de que el listado de procedimientos actuales no contenga procedimientos,
                     * tan solo se añade el procedimiento actual en el array de listado de procedimientos actuales.
                     */
                    if (typeof procedimientoActual === 'object') {
                        listProcedimientosActuales.push(procedimientoActual);
                    }
                }
            } else {
                /**
                 * Paso 3. Si el procedimiento actual no se encuentra dentro del listado de procedimientos RPS obtenidos,
                 * se incluye tan solo el procedimiento actual en el array de listado de procedimientos actuales.
                 */
                if (typeof procedimientoActual === 'object') {
                    listProcedimientosActuales.push(procedimientoActual);
                }
            }
        } else {
            /** 
             * Paso 1. En caso de que el procedimiento actual no se encuentre en el listado de procedimientos RPS,
             * se incluye tan solo el procedimiento actual en el array de listado de procedimientos actuales.
             */
            if (typeof procedimientoActual === 'object') {
                listProcedimientosActuales.push(procedimientoActual);
            }
        }
        return listProcedimientosActuales;
    }

    /**
     * @function getInfoProcedimientosRpsPCT2 Función que obtiene información sobre los procedimientos RPS
     * (llamada a la tabla de los match entre código RPS y procedimientos de MOAD)
     * @returns Devuelve la información obtenida de los procedimientos rps
     */
    const getInfoProcedimientosRpsPCT2 = async () => {
        let respuesta;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_RPS, { url: '/', method: 'get' }).then(response => {
            respuesta = response.data;
        }).catch(function (error) {
            handleSetMessage('Se ha producido un error al obtener los procedimeintos rps', 'error');
        });

        return respuesta;
    }

    /**
     * @function getPerfilExistente Función auxiliar de las funciones getPerfiles y getPerfilesNoIncluidosConvocatoria. Comprueba si existe un perfil ya añadido
     * @param {*} arrayPerfiles Recibe un array de objetos que contentiene todos los perfiles existentes 
     * @param {*} perfilAdd Objeto que se añade al perfil
     */
    function getPerfilExistente(arrayPerfiles, perfilAdd) {
        let existe = false;

        arrayPerfiles.forEach(buscarPerfiles => {
            if (buscarPerfiles.descripcion === perfilAdd.descripcion) {
                existe = true;
            }
        });
        return existe;
    }

    /**
     * @function getPerfilExistentePCT2 Función auxiliar de las funciones getPerfiles y getPerfilesNoIncluidosConvocatoria exclusiva para PCT2. Comprueba si existe un perfil ya añadido
     * @param {*} arrayPerfiles Recibe un array de objetos que contentiene todos los perfiles existentes 
     * @param {*} perfilAdd Objeto que se añade al perfil
     */
    function getPerfilExistentePCT2(arrayPerfiles, perfilAdd) {
        let existe = false;

        arrayPerfiles.forEach(buscarPerfiles => {
            if (buscarPerfiles.id === perfilAdd.id) {
                existe = true;
            }
        });
        return existe;
    }

    /**
     * @function getIdsPerfilesConvocatoria Obtiene los id de cada perfil de la convocatoria
     * La función devuelve un array con los id.
     * @param {*} convocatoria convocatoria seleccionada en el selector que se recibirá por parámetros
     */
    const getIdsPerfilesConvocatoria = (convocatoria) => {
        let idsObtenidos = [];
        if (convocatoria) {
            let perfiles = getPerfilConvocatoria(convocatoria);

            perfiles.forEach(element => {
                idsObtenidos.push(element.id);
            });

        }
        return idsObtenidos;
    }

    const ventanaUsuarioSinAltaAbrirCerrar = (accion) => {
        setMostrarVentana(accion);
        setIsLoading(accion)
    }

    const cargarValoresEffect = async () => {
        updateFormat();
        await getCodRpsFromProcedimiento();
        await getListConvocatorias();

        context.updateTitlePage(objTextSeleccionConvocatoriaPerfil.titulos.tituloPagina + procedimientoActual.descripcion);

        if (convocatoriaSeleccionada !== undefined && convocatoriaSeleccionada !== '') {
            values.seleccionConvocatoria = convocatoriaSeleccionada;
        }
        if (perfilSeleccionado !== undefined && perfilSeleccionado !== '') {
            values.perfil = perfilSeleccionado;
        }

        let redirect = loadState(localStorageName.redirect, false);
        if (redirect === 'clave') {
            await compruebaUsuario();
        }
    }

    const getProcedimientosRPS = async () => {
        let procedimientosRps = [];

        await checkCloudProperties(100);
        let listDir3 = cloudConfigProperties['CODIGO_DIR3_CONSEJERIAS'];

        if (listDir3) {
            let arrayDir3 = listDir3.trim().split(" ");

            for (const dir3 of arrayDir3) {
                await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROC_RPS, { url: dir3, method: 'get' }).then(response => {
                    procedimientosRps.push(...response.data);
                }).catch(function (error) {
                    procedimientosRps = [];
                    //handleSetMessage({ex: {err}, severity: 'error'})
                });
            }
        }
        return procedimientosRps
    }

    const comprobarMensajeBienvenida = () => {
        if (procedimientoActual && procedimientoActual.mensajeBienvenida) {
            setMostrarMensajeBienvenida(true);
        } else {
            setMostrarMensajeBienvenida(false);
        }
    }
    const postDatosSalto = (e, tipoAutenticacion) => {
        setIsLoading(true);
        const datosSalto = getDatosSaltoBandejaAnonimo(tipoAutenticacion);
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SALTO_BANDEJA, { url: '', method: 'post', data: datosSalto }).then(response => {
            saveState(localStorageName.redirect, 'bandeja', false);
            const url = response.data;
            window.location.href = url;
        }).catch(function (error) {
            if (error.response.status !== 200) {
                handleSetMessage("Ha ocurrido un error al intentar saltar a la bandeja.", 'error');
            }
        }).finally(function () {
            setIsLoading(false);
        });
    }

    const getDatosSaltoBandejaAnonimo = (tipoAutenticacion) => {
        const perfil = JSON.parse(values.perfil);

        let datosSalto = {
            tipoAutenticacion: tipoAutenticacion,/*Obtener el tipo de autenticacion de forma dinamica*/
            idProcedimientoActivo: procedimientoActual.id,
            idConvocatoriaActiva: values.seleccionConvocatoria.id,
            idOrdenActiva: values.seleccionConvocatoria.idOrden,
            idPerfilActivo: perfil.id,
            urlSalto: procedimientoActual.url
        }
        return datosSalto;
    }

    const handleChange = async (e, newValue, idComponente) => {
        let perfilesPublicos = [];
        let procedenciaConvocatoria = getProcedenciaConvocatoria(newValue);
        if (idComponente) {
            if (idComponente === idSelect) {

                newValue && newValue.perfiles && newValue.perfiles.forEach((perfil) => {

                    // Se añade estructura de control para las convocatorias provenientes de la PCT3
                    if (procedenciaConvocatoria === 'PCT3') {
                        perfilesPublicos.push(perfil);
                    } else {
                        perfil.publico && perfilesPublicos.push(perfil);
                    }
                });

                if (perfilesPublicos.length === 1) {
                    setValues({
                        ...values,
                        [idComponente]: newValue,
                        [idRadioGroup]: JSON.stringify(perfilesPublicos[0]),
                    });
                    dispatch(insertNewState({filnedName: 'perfilSeleccionado', value: perfilesPublicos[0]}));

                } else {
                    setValues({
                        ...values,
                        [idComponente]: newValue,
                        [idRadioGroup]: '',//Se reestablece el valor inicial cada vez que cambia el valor de la convocatoria
                    });
                    dispatch(deleteState({filnedName: 'perfilSeleccionado'}));
                }
                dispatch(insertNewState({filnedName: 'convocatoriaSeleccionada', value: newValue}));
                // Guardado del procedimineto al cual pertenece la convocatoria
                await guardarProcActual(procedenciaConvocatoria, newValue);
            } else {
                setValues({
                    ...values,
                    [idComponente]: newValue,
                });
                dispatch(insertNewState({filnedName: 'perfilSeleccionado', value: JSON.parse(newValue)}));
            }
        }
    }    

    /**
     * @function guardarProcActualPCT2 Función que almacena el procedimiento obtenido en local storage
     * @param {*} idProc 
     */
    const guardarProcActualPCT2 = async (idProc) => {
        let procedimientoObtenido = null, proc = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROCEDIMIENTOS_PCT2, { url: '/getProcedimiento/' + idProc, method: 'get' }).then(response => {
            procedimientoObtenido = response.data;
        }).catch(function (error) {
            handleSetMessage('Se ha producido un error al obtener el procedimiento', 'error');
        });

        if (procedimientoObtenido !== null) {
            proc = await addDataRpsPCT2(procedimientoObtenido);
        }
        return proc;
    }

    /**
     * @function guardarProcActualPCT3 Función que almacena el procedimiento obtenido en local storage
     * @param {*} id
     */
    const guardarProcActualPCT3 = async (id) => {
        let procedimientoObtenido = null, proc = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PROCEDIMIENTOS_PCT3, { url: '/' + id, method: 'get' }).then(response => {
            procedimientoObtenido = response.data;
        }).catch(function (error) {
            handleSetMessage('Se ha producido un error al obtener el procedimiento', 'error');
        });

        if (procedimientoObtenido !== null) {
            proc = await addDataRpsPCT3(procedimientoObtenido);
            proc.fromPct3 = true;
        }
        return proc;
    }

    const handleChangeMensajeBienvenida = (panel) => (event, newExpanded) => {
        setExpandedMensajeBienvenida(newExpanded ? panel : false);
    };

    /**Llamada al microservicio de clave-api-proxy para realizar el login con clave */
    const useLoginClave = () => {
        setIsLoading(true);

        saveState(localStorageName.redirect, 'clave', false);
        localStorage.setItem('origenLogin', '/SeleccionConvocatoriaPerfil');
        dispatch(insertNewState({filnedName: 'origenLogin', value: {redireccion: '/SeleccionConvocatoriaPerfil/'}}));

        loginClave(propertiesAppData.URL_LOGIN);
    }

    const onClickCertificado = () => {
        firmar();
    }

    const updateFormat = () => {
        if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    };

    /**
     * @function getLabelConvocatoria Función que inserta el texto a mostrar en las opciones del selector de convocatorias
     * @param {*} option 
     * @returns 
     */
    const getLabelConvocatoria = (option) => {
        let label = '';
       
        if (option) {
            let descripcion = (option.descripcion !== undefined) ? option.descripcion : '';
            let descripcionProc = (option.descripcionProc !== undefined) ? " - " + option.descripcionProc : '';
            label = descripcion +  descripcionProc;
        }
        return label.toUpperCase();
    }

    /**
     * @function getCodRpsFromProcedimiento Función que obtiene el código RPS de un procedimiento
     */
    const getCodRpsFromProcedimiento = async () => {
        let rps = null;
        // Paso 1. Se comprueba si se ha seleccionado un procedimiento
        if (procedimientoActual !== undefined && procedimientoActual !== null && procedimientoActual !== '') {
            let procedenciaProcedimiento = await getProcedenciaProcedimiento();

            // Paso 2. Se obtiene el código RPS dependiendo de la procedencia del procedimiento (PCT2 o PCT3)
            if (procedenciaProcedimiento === 'PCT2') {
                // Obtención del listado de procedimientos
                let procedimientosRPS = await getInfoProcedimientosRpsPCT2();
                // Se filtran los procedimientos RPS obtenidos y se comprueba si el procedimiento actual está entre uno de ellos
                let procedimientoObtenido = procedimientosRPS.filter((info) =>
                    (info.nombreProcedimiento ? info.nombreProcedimiento.toLowerCase() : '') === (procedimientoActual.nombre ? procedimientoActual.nombre.toLowerCase() : '')
                );
                rps = (procedimientoObtenido !== null && procedimientoObtenido.length !== 0) ? procedimientoObtenido[0].codigoRpa : null;
            } else {
                rps = procedimientoActual.codigoRps;
            }
        }
        return rps;
    }

    /**
     * @function mostrarPerfiles Función que muestra los perfiles de las convocatorias existentes,
     * siendo estas filtradas si son de PCT2 o PCT3
     * @returns 
     */
    const mostrarPerfiles = () => {
        let perfiles = [], perfPCT2 = [], perfPCT3 = [], perfilesObtenidos = [];

        if (convocatorias.length > 0) {
            // Paso 1. Obtención de las convocatorias pertenecientes a cada sistema (PCT2 o PCT3)
            let convoPCT2 = convocatorias.filter((convo) => convo.procedencia === 'PCT2');
            let convoPCT3 = convocatorias.filter((convo) => convo.procedencia === 'PCT3');

            // Paso 2. Obtención de los perfiles pertenecientes a las convocatorias de PCT2
            if (convoPCT2.length > 0) {
                perfPCT2 = getPerfilesPCT2(convoPCT2);
                perfilesObtenidos.push(...perfPCT2);
            }

            // Paso 3. Obtención de los perfiles pertenecientes a las convocatorias de PCT3
            if (convoPCT3.length > 0) {
                perfPCT3 = getPerfilesPCT3(convoPCT3);
                perfilesObtenidos.push(...perfPCT3);
            }

            // Paso 4. Obtención de los perfiles de las convocatorias de PCT2 y PCT3
            if (perfilesObtenidos.length > 0) {
                for (const perf of perfilesObtenidos) {
                    // Paso 4.1. Se comprueba si previamente existe el perfil
                    let existePerfil = false;
                    if (convocatoriaSeleccionada && convocatoriaSeleccionada.perfiles.length > 0) {
                        let perfilEncontrado = [];
                        if (convocatoriaSeleccionada.procedencia === 'PCT2') {
                            // Filtrar perfiles de la convocatoria seleccionada por ID y descripción
                            perfilEncontrado = convocatoriaSeleccionada.perfiles.filter((p) => p.id === perf.id && p.descripcion === perf.descripcion);
                        } else {
                            // Filtrar perfiles de la convocatoria seleccionada solo por descripción
                            perfilEncontrado = convocatoriaSeleccionada.perfiles.filter((p) => p.descripcion === perf.descripcion);
                        }
                        // Si el perfil se encuentra en la lista de perfiles de la convocatoria seleccionada, existePerfil será true
                        existePerfil = perfilEncontrado.length > 0;
                    }
                    // Si el perfil existe en convocatoriaSeleccionada.perfiles, agregarlo a la lista de perfiles
                    existePerfil && perfiles.push(perf);
                }
            }
        }
        return perfiles;
    }

    /**
     * @function updateUrl Función que actualiza la url de procedencia del procedimiento
     */
    const updateUrl = (procedimiento, procedenciaConvocatoria) => {
        if ((procedimientoActual !== undefined && procedimientoActual !== '') && procedenciaConvocatoria !== null) {            
            let urlProcedimiento = `/${procedenciaConvocatoria}_${procedimiento.id}`;
            dispatch(insertNewState({filnedName: 'urlProcedenciaProcedimiento', value: urlProcedimiento}));
            localStorage.setItem('urlProcedenciaProcedimiento', urlProcedimiento);
        }
    }

    const irAccesoConContrasena = (e, entidad) => {
        history.push('/AccesoConContrasena');
    }

    const getUrlProcedimiento = async () => {
        let urlActual = window.location.hash;
        let posicion = urlActual.lastIndexOf('/', urlActual.length);
        let urlProcedimiento = urlActual.substring(posicion, urlActual.length);
        dispatch(insertNewState({filnedName: 'urlProcedenciaProcedimiento', value: urlProcedimiento}));
        return urlProcedimiento;
    };

    return {
        values, setValues, convocatorias, isPhoneVersion, handleChange, updateFormat, mostrarPerfiles, mostrarAcceso,
        getIdsPerfilesConvocatoria, getEstadoBoton, alerts, message, setMessage, getLabelConvocatoria,
        mostrarMensajeBienvenida, expandedMensajeBienvenida, handleChangeMensajeBienvenida,
        procActual, useLoginClave, onClickCertificado, compruebaUsuario, postDatosSalto,
        isLoading, ventanaUsuarioSinAltaAbrirCerrar, mostrarVentana, pintarPantalla, context, getProcedenciaProcedimiento,
        irAccesoConContrasena, convocatoriaSeleccionada, perfilSeleccionado, montarPantallaPorUrl, cargarValoresEffect, setIsLoading, setPintarPantalla, metodosAcceso
    };
}

export default useFunctions;